import { Injectable, TemplateRef } from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MatDialogConfig,
} from '@angular/material/dialog';
import { FnConfirmModalComponent } from './fn-confirm-modal.component';
import { DialogData } from '../fn-dialog.model';
import { ComponentType } from '@angular/cdk/portal';

/**
 * ModalServies uses Material Dailog to open confirmation modal and components or template as Modal.
 */
@Injectable()
export class FnModalService {
	/**
	 * Creates an instance of fn modal service.
	 * @param dialog MatDialog Object to open Components as Modal.
	 */
	constructor(private dialog: MatDialog) {}

	/**
	 * Opens confirm modal
	 * @param [dialogData] data Map given to dialog object with default title value = "Confirmation"
	 * and content: 'Do you want to delete this?' }
	 *
	 * @returns Reference to the newly-opened confirmation Modal.
	 */
	public openConfirmModal(
		dialogData: DialogData = {
			title: 'Confirmation',
			content: 'Do you want to delete this?',
			type: 'danger',
		},
		config?: MatDialogConfig
	): MatDialogRef<FnConfirmModalComponent, any> {
		return this.dialog.open(FnConfirmModalComponent, {
			data: dialogData,
			restoreFocus: false,
			...config,
		});
	}

	/**
	 * Opens custom modal dialog containing the given component.
	 *
	 * @param componentOrTemplateRef Type of the component to load into the  Custom Modal,
	 * or a TemplateRef to instantiate as the  Custom Modal content.
	 *
	 * @param [config] Extra configuration options.
	 *
	 * @returns  Reference to the newly-opened Custom Modal.
	 */
	public openCustomModal(
		componentOrTemplateRef: ComponentType<any> | TemplateRef<any>,
		config?: MatDialogConfig
	) {
		return this.dialog.open(componentOrTemplateRef, {
			restoreFocus: false,
			disableClose: true,
			...config,
		});
	}

	/**
	 * Opens modal dialog containing the given component.
	 *
	 * @param componentOrTemplateRef Type of the component to load into the dialog, or a TemplateRef to instantiate as the  Modal content.
	 *
	 * @param [config] Extra configuration options.
	 *
	 * @returns  Reference to the newly-opened Modal.
	 */
	public openModal(
		componentOrTemplateRef: ComponentType<any> | TemplateRef<any>,
		config?: MatDialogConfig
	) {
		return this.dialog.open(componentOrTemplateRef, {
			data: config.data,
			width: '800px',
			restoreFocus: false,
			hasBackdrop: config.hasBackdrop,
			disableClose: config.disableClose || false,
		});
	}
}
